import { useState } from "react";
import { Mail, ChevronDown } from "lucide-react";
import { useLoad } from "@/lib/api";
import { useMe } from "@/lib/me";
import { fmtDate } from "@/lib/format";
import { PageHead, Empty } from "@/components/Bits";

const tone = (s) => (s === "sent" ? "bg-emerald-50 text-emerald-700" : s.startsWith("error") || s.startsWith("not sent") ? "bg-rose-50 text-rose-700" : "bg-slate-100 text-slate-600");

export default function EmailsPage() {
  const me = useMe();
  const list = useLoad("/mail");
  const [open, setOpen] = useState(null);
  return (
    <div>
      <PageHead title="Emails" sub={me.features.shared_mail ? "Sent from our shared address in your pharmacy's name. Link your own mailbox in Settings." : me.features.email_sending ? `Sent from ${me.features.mailbox}.` : "Email sending is not switched on yet — messages are logged here only."} />
      {list.data?.length === 0 && <Empty icon={Mail} title="No emails yet" text="Queries, chasers and alerts appear here." testid="emails-empty" />}
      <div className="space-y-2" data-testid="emails-list">
        {(list.data || []).map((m, i) => (
          <div key={i} className="rounded-2xl border border-slate-200 bg-white" data-testid={`email-row-${i}`}>
            <button onClick={() => setOpen(open === i ? null : i)} className="flex w-full items-center gap-3 p-4 text-left">
              <div className="min-w-0 flex-1">
                <p className="truncate font-semibold">{m.subject}</p>
                <p className="truncate text-xs text-slate-500">{m.audience === "owner" ? "To owners" : "To wholesaler"}: {(m.to || []).join(", ") || "—"} · {fmtDate(m.at)}</p>
              </div>
              <span className={`hidden rounded-full px-2.5 py-0.5 text-xs font-semibold sm:inline ${tone(m.status)}`} data-testid={`email-status-${i}`}>{m.status}</span>
              <ChevronDown className={`h-4 w-4 transition-transform ${open === i ? "rotate-180" : ""}`} />
            </button>
            {open === i && <pre className="whitespace-pre-wrap border-t border-slate-100 p-4 font-sans text-sm text-slate-700">{m.body}<span className={`mt-3 block w-fit rounded-full px-2.5 py-0.5 text-xs font-semibold sm:hidden ${tone(m.status)}`}>{m.status}</span></pre>}
          </div>
        ))}
      </div>
    </div>
  );
}
